import moment from 'moment'

export const paginationData = [
	{
		col1: moment(
			'Thu Aug 02 2018 10:03:24 GMT-0300 (Horário Padrão de Brasília)'
		).format('DD/MM/YYYY'),
		col2: 'Tiago 1',
		col3: '1',
		col4: '007.909.080-01',
		col5: '2067055729',
		col6: 'tfuelber@gmail.com',
		col7: '(51) 98224-2758'
	},
	{
		col1: moment(
			'Thu Aug 10 2018 10:03:24 GMT-0300 (Horário Padrão de Brasília)'
		).format('DD/MM/YYYY'),
		col2: 'Tiago 2',
		col3: '2',
		col4: '007.909.080-02',
		col5: '2067055730',
		col6: 'ufuelber@gmail.com',
		col7: '(51) 98224-2759'
	},
	{
		col1: moment(
			'Thu Aug 01 2018 10:03:24 GMT-0300 (Horário Padrão de Brasília)'
		).format('DD/MM/YYYY'),
		col2: 'Tiago 3',
		col3: '3',
		col4: '007.909.080-03',
		col5: '2067055731',
		col6: 'vfuelber@gmail.com',
		col7: '(51) 98224-2760'
	},
	{
		col1: moment(
			'Thu Aug 25 2018 10:03:24 GMT-0300 (Horário Padrão de Brasília)'
		).format('DD/MM/YYYY'),
		col2: 'Tiago 4',
		col3: '4',
		col4: '007.909.080-04',
		col5: '2067055732',
		col6: 'xfuelber@gmail.com',
		col7: '(51) 98224-2761'
	}
]
